import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import StyledSwitch from "@/components/ui/customs/StyledSwitch";
import { ControlledUnifiedInput } from "@/components/ui/customs/controlled-unified-input";
import { ExpeditionBoDeliveryInfoFormData } from "@/types/forms/bo/expeditionBo.form";
import { ClientAdditionalInfo } from "./clientAdditionalInfo";
import { DaeNumbers } from "./daeNumbers";
import { MrnNumbers } from "./mrnNumbers";

export const CustomsInformation = () => {
  const { t } = useTranslation("boExpeditionForm");
  const { control } = useFormContext<ExpeditionBoDeliveryInfoFormData>();

  const sampleEnabled = useWatch({ control, name: "options.sample" });
  const personalUseEnabled = useWatch({ control, name: "options.presonalUseToggle" });

  return (
    <div className="flex w-full flex-col gap-3">
      <ClientAdditionalInfo />
      <DaeNumbers />
      <MrnNumbers />
      <div className="flex w-full flex-col gap-4 @xl:flex-row @xl:items-center @xl:gap-2">
        <div className="flex flex-1 flex-row items-center gap-2">
          <StyledSwitch control={control} name="options.sample" />
          <span className="w-24 shrink-0 text-sm font-medium text-gray-800">
            {t("customsInformation.sampleLabel")}
          </span>
        </div>
        <ControlledUnifiedInput
          control={control}
          name="options.sampleText"
          placeholder={t("customsInformation.samplePlaceholder")}
          disabled={!sampleEnabled}
          wrapperClassName="w-full"
        />
      </div>
      <div className="flex w-full flex-col gap-4 @xl:flex-row @xl:items-center @xl:gap-2">
        <div className="flex flex-1 flex-row items-center gap-2">
          <StyledSwitch control={control} name="options.presonalUseToggle" />
          <span className="w-24 shrink-0 text-sm font-medium text-gray-800">
            {t("customsInformation.personalUseLabel")}
          </span>
        </div>
        <ControlledUnifiedInput
          control={control}
          name="options.personalUse"
          placeholder={t("customsInformation.personalUsePlaceholder")}
          wrapperClassName="w-full"
          disabled={!personalUseEnabled}
        />
      </div>
    </div>
  );
};
